export const ORDER_GET_LOADING = "order/get/loading"

export const ORDER_GET_ERROR = "order/get/error"

export const ORDER_GET_SUCCESS = "order/get/success"

export const ORDER_REMOVE = "order/delete"